import { useMemo } from 'react';
import { ENDPOINTS } from '../../endpoints';
import { Service } from '../base';
import dynamicAxios from '../../utils/axios';
import useServices from '../../hooks/useServices';
import { CollectParsedCvErrors, UnanalysedParsedCv } from './types';

class ServiceCvParsing extends Service {
  getUnanalysedParsedCv() {
    return this.axiosInstance.get<UnanalysedParsedCv>(ENDPOINTS.cvParsing.unanalysedParsedCv);
  }
  collectErrors(params: CollectParsedCvErrors) {
    return this.axiosInstance.post(ENDPOINTS.cvParsing.collectErrors, params);
  }
  setParsedCvAsAnalysed(cvUrl: string) {
    return this.axiosInstance.get(ENDPOINTS.cvParsing.setCvAsAnalysed, { params: { cv_url: cvUrl } });
  }
  getCorrectedCvCount() {
    return this.axiosInstance.get<number>(ENDPOINTS.cvParsing.correctedCvCount);
  }
}

export function useCvParsingService() {
  const { baseUrl, jwt } = useServices();
  return useMemo(() => new ServiceCvParsing(dynamicAxios(baseUrl, jwt)), [baseUrl, jwt]);
}

export default useCvParsingService;
export * from './types';
